import { Spinner } from 'components/design';
import OWContainer from 'styles/styled-components/ow-container';
import { PlaceForm } from '../components/place-form';
import useController from '../controllers/add-place-controller';

export const AddPlaceRoute = () => {
    const { formData, terminals, website, cities, onSubmit, onCancel, onChange, isLoading, isAddPlaceLoading, errors } =
        useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <PlaceForm
                    formData={formData}
                    terminals={terminals}
                    cities={cities}
                    website={website}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onChange={onChange}
                    isSaveLoading={isAddPlaceLoading}
                    errors={errors}
                />
            )}
        </OWContainer>
    );
};
